import { useEffect, useState } from 'react';

/**
 * Check for secure context without SSR glitches.
 *
 * @returns true if the current context is secure (HTTPS) or false if not
 */
export default function useSecureContext() {
  /**
   * We set this to true when we detect SSR so that generated pages
   * will not contain warnings about secure context.
   */
  const [secureContext, setSecureContext] = useState<boolean>(
    typeof window === 'undefined' || window.isSecureContext
  );

  /**
   * And after that on client we check if we are in a secure context
   * and set the state accordingly.
   */
  useEffect(() => {
    setSecureContext(window.isSecureContext);
  }, []);

  return secureContext;
}
